import { memo } from 'react';
import { MarkdownRenderer } from '../../shared';
import styles from './StreamingMessage.module.css';

export interface StreamingMessageProps {
  content: string;
}

/**
 * StreamingMessage displays a markdown message with a blinking cursor,
 * optimized for streaming/typewriter effect in chat UIs.
 */
export function StreamingMessage(props: StreamingMessageProps) {
  const { content } = props;

  return (
    <div className={styles.message}>
      <MarkdownRenderer className={styles.messageContent} content={content} />
      <span className={styles.streamingCursor}>|</span>
    </div>
  );
}

// Memoize for performance if streaming updates are frequent
export const MemoizedStreamingMessage = memo(StreamingMessage);